<template>
  <div>
    <Nav></Nav>
    <b-container fluid="xl">
      <b-row>
        <b-col>
          <h1> Alta de Insumos</h1>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button variant="default" @click="$router.push('/supply')">Crear Insumo</b-button>
          <template v-if="hasPermission('rrn:central:supplies:downloadFormats')">
            <b-button variant="outline-secondary" class="ml-1" @click="$bvModal.show('modal-supplyPurchaseFormat')">
              <i class="fas fa-print mr-1"></i> Formato de compras
            </b-button>
            <b-button variant="outline-secondary" class="ml-1" @click="$bvModal.show('modal-supplyInventoryFormat')">
              <i class="fas fa-print mr-1"></i> Formato de inventario
            </b-button>
          </template>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label="Buscar:">
            <b-form-input type="search" v-model="search" debounce="300" placeholder="Código, nombre, descripción o categoría"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-table small striped hover :items="filteredSupplies" :fields="tableFields" responsive
            :per-page="byPage" :current-page="page" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
            :tbody-tr-class="rowClass">
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>
            <template #cell(buttons)="data">
              <b-button-group vertical>
                <b-button size="sm" variant="warning" @click="editSupply(data.item.id)">Editar</b-button>

              </b-button-group>
            </template>
            <template #cell(category_name)="data">
              <span :class="{ 'text-muted': !(data.item.supply_category && data.item.supply_category.name) }">{{ data.item.category_name }}</span>
            </template>
            <template #cell(status)="data">
              <b-badge pill v-if="data.item.status" variant="success">ACTIVO</b-badge>
              <b-badge pill v-else-if="!data.item.status" variant="danger">INACTIVO</b-badge>
            </template>
            <template #cell(image)="data">
              <img :src="axios.defaults.baseURL + '/' + data.item.image">
            </template>
          </b-table>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-pagination v-model="page" :total-rows="filteredSupplies.length" :per-page="byPage"
            aria-controls="my-table"></b-pagination>
        </b-col>
      </b-row>
      <b-modal id="modal-supplyPurchaseFormat" :hide-footer="true" size="lg" title="Descargar formato de compras">
        <SupplyFormatDownload kind="compras" />
      </b-modal>
      <b-modal id="modal-supplyInventoryFormat" :hide-footer="true" size="lg" title="Descargar formato de inventario">
        <SupplyFormatDownload kind="inventario" />
      </b-modal>
    </b-container>
  </div>
</template>
<script>
import Nav from "../components/Nav.vue";
import axios from "axios";
import SupplyFormatDownload from "../components/SupplyFormatDownload.vue";
import { permissionMixin } from "../mixins/permissionMixin";

// The list state (page, search, sort) lives in the URL and is mirrored in
// sessionStorage, so coming back from editing a supply lands on the same view.
const LIST_STATE_KEY = "supplies.listState";

function readStoredState() {
  try {
    return JSON.parse(sessionStorage.getItem(LIST_STATE_KEY)) || {};
  } catch (e) {
    return {};
  }
}

export default {
  name: "Supplies",
  mixins: [permissionMixin],
  components: { Nav, SupplyFormatDownload },
  data() {
    return {
      byPage: 20,
      page: 1,
      suppliesTable: [],
      search: "",
      sortBy: "",
      sortDesc: false,
      // Page to restore once the data is loaded (b-pagination clamps to 1 while empty).
      pendingPage: 1,
      lastEditedId: null,
      subgroups: [],
      groups: [],
      tableFields: [
        { key: "id", label: "ID", sortable: true, sortDirection: "desc" },
        { key: "code", label: "Codigo", sortable: true },
        { key: "name", label: "Nombre", sortable: true },
        { key: "description", label: "Descripcion", sortable: true },
        { key: "category_name", label: "Categoría", sortable: true },
        { key: "unit", label: "Unidad", sortable: true },
        { key: "status", label: "Status", sortable: true },
        { key: "buttons", sortable: true },
      ],
    };
  },
  computed: {
    filteredSupplies() {
      const q = this.normalize(this.search.trim());
      if (!q) return this.suppliesTable;
      return this.suppliesTable.filter((s) =>
        [s.id, s.code, s.name, s.description, s.unit, s.category_name].some((v) => this.normalize(String(v == null ? "" : v)).includes(q))
      );
    },
    listState() {
      return { page: this.page, q: this.search, sort: this.sortBy, desc: this.sortDesc };
    },
  },
  watch: {
    search() {
      if (this.loaded) this.page = 1;
    },
    listState() {
      if (this.loaded) this.syncState();
    },
  },
  created() {
    this.loaded = false;
    // URL wins (shared links, browser back); otherwise restore the last session state.
    const q = this.$route.query;
    const state = Object.keys(q).length ? { page: q.page, q: q.q, sort: q.sort, desc: q.desc === "1" } : readStoredState();
    this.search = state.q || "";
    this.sortBy = state.sort || "";
    this.sortDesc = !!state.desc;
    this.pendingPage = parseInt(state.page, 10) || 1;
    this.lastEditedId = state.edited || null;
  },
  mounted() {
    this.getAllSupplies();
  },
  methods: {
    syncState() {
      const state = this.listState;
      try {
        sessionStorage.setItem(LIST_STATE_KEY, JSON.stringify({ ...state, edited: this.lastEditedId }));
      } catch (e) {
        /* storage unavailable: URL still keeps the state */
      }
      const query = {};
      if (state.page > 1) query.page = String(state.page);
      if (state.q) query.q = state.q;
      if (state.sort) query.sort = state.sort;
      if (state.sort && state.desc) query.desc = "1";
      if (JSON.stringify(query) !== JSON.stringify(this.$route.query)) {
        this.$router.replace({ query }).catch(() => {});
      }
    },
    normalize(text) {
      return text.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    },
    editSupply(id) {
      this.lastEditedId = id;
      try {
        sessionStorage.setItem(LIST_STATE_KEY, JSON.stringify({ ...this.listState, edited: id }));
      } catch (e) {
        /* ignore */
      }
      this.$router.push("/supply/" + id);
    },
    rowClass(item, type) {
      return type === "row" && item && item.id === this.lastEditedId ? "table-warning" : "";
    },
    getAllSupplies() {
      let that = this;
      // Always load the full list (it includes the category); filtering is client-side.
      axios
        .get("/supplies")
        .then(function (response) {
          that.suppliesTable = response.data.map((s) => ({
            ...s,
            category_name: (s.supply_category && s.supply_category.name) || "Sin categoría",
          }));
          that.$nextTick(() => {
            const pages = Math.max(1, Math.ceil(that.filteredSupplies.length / that.byPage));
            that.page = Math.min(that.pendingPage, pages);
            that.loaded = true;
            that.syncState();
          });
        })
        .catch(function (err) {
          console.error(err)
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    makeToast(title, content, variant) {
      this.$bvToast.toast(content, {
        title,
        variant,
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
  },
};
</script>
